import { useEffect, useContext } from "react";
import { Box, Button } from '@mui/material';
import { Sync as SyncIcon } from '@mui/icons-material';
import { SalesProductReport } from "../../../global/API";
import { DataSetArray } from "./DataSetArray";
import Excel from '../../../../../assets/images/icons/excel.png';
import ReactExport from 'react-data-export';
import moment from "moment/moment";
import { ToolContext } from "../../../../../core/context/ToolContext";

import { FeatureIdState } from "../../../toolUsage/global/GlobalFcn";
import { CreateFeatureLogs } from "../../../global/API";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export const Generate = () => {
    const {tool_state, report_state, global_component_state} = useContext(ToolContext)
    const {__SESSION} = tool_state
    const {form, comProductIds, generateForm, salesProductData, salesProductList} = report_state
    const {snackBarLoader} = global_component_state
    const tool_id =  process.env.REACT_APP_TID_BIZ;


    const handleGenerate = async() => {
        await __generateData(0)
    }

    const SendFeatureLogs = async()=>{
        let body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState('reports')}->2`,
            feature_id: 1,
            feature_name: "branch-product-sales-report",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2
        }
        await CreateFeatureLogs(body)
    }
    

    const __generateData = async(offset) => {
        if (form.data.to === '' || form.data.from === '' || form.data.to < form.data.from) {
            snackBarLoader.set({...snackBarLoader.data, snackbar:true, msg: `Invalid Date!`, type: "error"})
            return
        }else{
            generateForm.set((prev) => ({...prev, infiniteLoad:true}))
        }
        let qsp = {
            branch_id:form.data.branch_id,
            company_id:__SESSION.data.uaccess[0].company_id,
            product_id:form.data.product_id > 0 ? form.data.branch_id === 0 ? JSON.stringify(comProductIds) : JSON.stringify([form.data.product_id]) : form.data.product_id,
            from:form.data.from,
            to:form.data.to,
            limit:generateForm.data.limit,
            offset:offset   
        }
        let res = await SalesProductReport(qsp)
        SendFeatureLogs()
        res = res.filter(item => parseInt(item.visible) === 1);
        if (res) {
            if (res.length === 0) {
                FinalData([...salesProductData.data, ...res])
                return
            }else{
                ///// LOADER VALIDATION
                if (res.length < generateForm.data.limit) {
                    FinalData([...salesProductData.data, ...res])
                    return
                }else{
                    generateForm.set((prev) => ({...prev, offset:res.length + salesProductData.data.length}))
                }
                ///// STATE LIST DATA
                salesProductData.set([...salesProductData.data, ...res])
            }   
        }
    }

    const FinalData = (salesProductData) => {
        salesProductList.set(salesProductData)
        generateForm.set((prev) => ({...prev, infiniteLoad:false, offset:0}))
        // salesProductList.set([])
    }

    useEffect(() => {
        if (generateForm.data.offset !== 0) {
            __generateData(generateForm.data.offset)
        }
        //eslint-disable-next-line
    }, [salesProductData.data])

    return (
        <Box minHeight="55px" display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
            {salesProductList.data.length > 0 && (
                <ExcelFile filename={`Sales_Product_Reports_${moment(new Date()).format('MM/DD/YYYY')}`}
                    element={
                        <Box display="flex" alignItems="center" className="c-pointer" bgcolor="#d5ffe6ff" borderRadius={2} padding="12px 16px" minWidth="200px">
                            <img src={Excel} alt="excel-img" />
                            <Box ml="10px" color="#1D6F42">Export in excel</Box>
                        </Box>
                    }
                >
                    <ExcelSheet dataSet={DataSetArray(salesProductList.data)} name="Reports" />
                </ExcelFile>
            )}
            <Box id="walkthrough-branch-product-report-step-5" onClick={handleGenerate} component={Button} disableFocusRipple={true} minHeight="50px" minWidth="130px" borderRadius={3} display="flex" alignItems="center" justifyContent="center" bgcolor="primary.main" color="#fff" sx={{border:"2px solid #EBEBEB", ':hover':{bgcolor:'primary.main', color:'#FFFFFF'}}} startIcon={<SyncIcon/>}>
                <Box fontSize={16} fontWeight={400} lineHeight="19px">Generate</Box>
            </Box>
        </Box>
    )
}